<div
  class="{{ absencePlannerEventCSSClass }} draggable resizable k-overflow-hidden k-pos-absolute"
  [attr.data-event-id]="plannerEventModel().id"
  [attr.data-user-id]="plannerEventModel().userId"
  [attr.data-start-date]="DateTimeHelper.format(plannerEventModel().start)"
  [attr.data-end-date]="DateTimeHelper.format(plannerEventModel().end)"
  [style.width.px]="eventWidth()"
  [style.left.px]="eventLeft()"
  [style.top.px]="eventTop()"
  [style.margin-block]="maxParallelIndexPerGroup() === 0 ? 'auto' : '0'"
  data-x="0"
  data-y="0"
  appPlannerEventInteraction
  #eventWrapper
>
  <app-event-resize-handle
    #leftDragEdge
    [alignment]="EventDragHandleAlignment.Left"
    [plannerEventModel]="plannerEventModel()"
  />
  <app-event-resize-handle
    #rightDragEdge
    [alignment]="EventDragHandleAlignment.Right"
    [plannerEventModel]="plannerEventModel()"
  />
</div>
